Object.defineProperty(exports, "__esModule", { value: true });
class ValueTransformer {
    constructor(options) {
        this.options = options;
    }
    bail(options) {
        return false;
    }
    transform(value) {
        if (this.bail(this.options)) {
            return value;
        }
        if (value instanceof Array) {
            return this.handleArray(value);
        }
        else if (value && value.constructor === Object && typeof value === 'object') {
            //this should only be true for plain objects, not any built-in types like a new String(), new Date(), Elements, etc.
            return this.handleObject(value);
        }
        else {
            return this.transformValue(value, this.options);
        }
    }
    handleObject(val) {
        const cloned = Object.assign({}, val);
        Object.keys(cloned).forEach(key => {
            cloned[key] = this.transform(cloned[key]);
        });
        return cloned;
    }
    handleArray(val) {
        const cloned = [...val];
        for (let i = 0; i < cloned.length; i++) {
            cloned[i] = this.transform(cloned[i]);
        }
        return cloned;
    }
}
exports.default = ValueTransformer;
//# sourceMappingURL=ValueTransformer.js.map